var map = {
	"./adult/nn/2 1 ordkjedetekst.mp3": 725,
	"./adult/no/2 1 ordkjedetekst.mp3": 726,
	"./adult/se/2 1 ordkjedetekst.mp3": 727,
	"./youth/de/2 1 ordkjedetekst.mp3": 728,
	"./youth/nn/2 1 ordkjedetekst.mp3": 729,
	"./youth/no/2 1 ordkjedetekst.mp3": 730,
	"./youth/se/2 1 ordkjedetekst.mp3": 731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;